import sanityClient from '@sanity/client'

export default sanityClient({
    projectId:"5ry2f78g",
    dataset:"production"
})